import React, { type FC, type ReactElement } from 'react';
import * as util from '#packages/util';
import TopBarButton from '../topBarButton/topBarButtonWithTooltip';
import * as symbols from '@wix/santa-editor-symbols';
//@ts-expect-error-next-line
import coreMultilingual from 'coreMultilingual';

const customSymbol = React.createElement(symbols.symbol, { name: 'arrowDown' });

interface LanguagePanelButtonProps {
  onClick: () => void;
  regionCode?: string;
  twoLettersLanguageCode: string;
  tooltip: ReactElement;
  countryCode?: string;
  shouldHideLanguageIcon: boolean;
}

export const LanguagePanelButton: FC<LanguagePanelButtonProps> = ({
  onClick,
  tooltip,
  twoLettersLanguageCode,
  regionCode,
  countryCode,
  shouldHideLanguageIcon,
}) => {
  const getFlagUrl = (countryCode: string) => {
    return coreMultilingual.utils.getFlagIconUrl(
      util.serviceTopology.scriptsLocationMap['linguist-flags'],
      coreMultilingual.flagCountryIconType.rounded,
      countryCode,
    );
  };

  const localeName = util.multilingual.languages.getLanguageFullName(
    twoLettersLanguageCode,
    regionCode,
  );

  return (
    <TopBarButton
      tooltip={tooltip}
      automationId="top-bar-button-flag"
      onClick={onClick}
      className="language-selector-top-bar-button"
    >
      {countryCode && !shouldHideLanguageIcon && (
        <div className="flagWrapper">
          <img src={getFlagUrl(countryCode)} alt={countryCode} />
        </div>
      )}
      <div className="localeNameWrapper">
        <div className="localeName">{localeName}</div>
      </div>
      <div>{customSymbol}</div>
    </TopBarButton>
  );
};
